import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';

import axios from '../../../../services/axios';

import { Loading } from '../../../../components';
import { setInspectionObservation } from '../../../../store/modules/inspections/actions';
import { Main, ShadowButton } from './styles';

function Observation({ inspection, onRemoved }) {
  const dispatch = useDispatch();
  const [observacoes, setObservacoes] = useState(inspection.observacoes || '');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setObservacoes(inspection.observacoes || '');
  }, [inspection.id, inspection.observacoes]);

  async function updateObservation(value, successMessage) {
    setSaving(true);

    try {
      await axios.put(`${process.env.REACT_APP_API_INSPECTIONS_UPDATE}/${inspection.id}`, {
        observacoes: value,
      });

      dispatch(setInspectionObservation(value));
      toast.success(successMessage);

      if (!value.trim()) onRemoved();
    } catch (err) {
      toast.error('Não foi possível atualizar a observação, tente novamente!');
    } finally {
      setSaving(false);
    }
  }

  function handleSave(event) {
    event.preventDefault();
    updateObservation(observacoes, 'Observação atualizada com sucesso!');
  }

  function handleRemove() {
    updateObservation('', 'Observação removida com sucesso!');
  }

  return (
    <Main>
      {saving ? <Loading /> : null}
      <form onSubmit={handleSave}>
        <TextField
          id="observacoes"
          label="Observações do Vaso"
          multiline
          rows={10}
          variant="outlined"
          fullWidth
          value={observacoes}
          onChange={(event) => setObservacoes(event.target.value)}
        />
        <div className="actions">
          <ShadowButton
            type="button"
            width="140px"
            height="40px"
            background="#c62828"
            color="#f5f5f5"
            onClick={handleRemove}
            disabled={saving}
          >
            Remover
          </ShadowButton>
          <ShadowButton
            type="submit"
            width="180px"
            height="40px"
            background="#4CAF50"
            color="#f5f5f5"
            disabled={saving || !observacoes.trim()}
          >
            Salvar Alterações
          </ShadowButton>
        </div>
      </form>
    </Main>
  );
}

Observation.propTypes = {
  inspection: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    observacoes: PropTypes.string,
  }).isRequired,
  onRemoved: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  inspection: state.inspections.inspection,
});

export default connect(mapStateToProps)(Observation);
